export const formatPhoneNumberByLength = (input: string | number): string => {
    const raw = input.toString().replace(/\D/g, '');

    if (raw.length === 10) {
        const area = raw.slice(0, 3);
        const prefix = raw.slice(3, 6);
        const line = raw.slice(6);
        return `(${area}) ${prefix}-${line}`;
    }

    if (raw.length > 10) {
        const codeLength = raw.length - 10;
        const country = raw.slice(0, codeLength);
        const area = raw.slice(codeLength, codeLength + 3);
        const prefix = raw.slice(codeLength + 3, codeLength + 6);
        const line = raw.slice(codeLength + 6);
        return `+${country} (${area}) ${prefix}-${line}`;
    }

    return input.toString();
};
